{
    "name": "app",
    "version": "1.0.12",
    "scripts": {
        "ng": "ng",
        "start": "ng serve --port 2500",
        "build": "ng build",
        "buildForTeamcity": "ng build --configuration %ENVIRONMENT%",
        "test": "ng test",
        "lint": "ng lint",
        "e2e": "ng e2e",
        "i18n:extract:all": "npm run i18n:extract && npm run i18n:extract:tools && npm run i18n:extract:law-baner && npm run i18n:extract:document && npm run i18n:extract:footer && npm run i18n:extract:settings-menu && npm run i18n:extract:avatar && npm run i18n:extract:table",
        "i18n:extract": "ngx-translate-extract -i ./src/app -o ./src/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:tools": "ngx-translate-extract -i ./src/sb-tools -o ./src/sb-tools/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:law-baner": "ngx-translate-extract -i ./src/sb-modules/Frontend-Cookie-Law-Banner-Module -o ./src/sb-modules/Frontend-Cookie-Law-Banner-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:document": "ngx-translate-extract -i ./src/sb-modules/Frontend-Document-Viewer-Module -o ./src/sb-modules/Frontend-Document-Viewer-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:footer": "ngx-translate-extract -i ./src/sb-modules/Frontend-Footer-Module -o ./src/sb-modules/Frontend-Footer-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:settings-menu": "ngx-translate-extract -i ./src/sb-modules/Frontend-Settings-Menu-Module -o ./src/sb-modules/Frontend-Settings-Menu-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:avatar": "ngx-translate-extract -i ./src/sb-modules/Frontend-User-Avatar-Module -o ./src/sb-modules/Frontend-User-Avatar-Module/assets/i18n/en.json --sort -f json --clean",
        "i18n:extract:table": "ngx-translate-extract -i ./src/sb-modules/Frontend-Table-Module -o ./src/sb-modules/Frontend-Table-Module/assets/i18n/en.json --sort -f json --clean",
        "prepare": "husky install",
        "prettier": "npx prettier --write .",
        "serve:ssr": "node dist/app/server/server.mjs",
        "postinstall": "patch-package"
    },
    "private": true,
    "dependencies": {
        "@ali-hm/angular-tree-component": "^20.0.3",
        "@angular-devkit/build-angular": "^20.3.1",
        "@angular/animations": "^20.3.0",
        "@angular/cli": "^20.3.1",
        "@angular/common": "^20.3.0",
        "@angular/compiler": "^20.3.0",
        "@angular/compiler-cli": "^20.3.0",
        "@angular/core": "^20.3.0",
        "@angular/forms": "^20.3.0",
        "@angular/platform-browser": "^20.3.0",
        "@angular/platform-browser-dynamic": "^20.3.0",
        "@angular/platform-server": "^20.3.0",
        "@angular/router": "^20.3.0",
        "@angular/ssr": "^20.3.1",
        "@ctrl/ngx-emoji-mart": "^9.3.0",
        "@fortawesome/fontawesome-free": "^7.0.1",
        "@microsoft/applicationinsights-web": "^3.3.0",
        "@ng-select/ng-select": "^13.5.0",
        "@ngx-translate/core": "^17.0.0",
        "ace-builds": "^1.43.5",
        "ajv": "^8.12.0",
        "angular2-notifications": "^16.0.1",
        "chart.js": "^4.5.0",
        "express": "^5.1.0",
        "file-saver": "^2.0.5",
        "husky": "^8.0.3",
        "intl-tel-input": "^25.10.6",
        "jquery": "^3.7.1",
        "jspdf": "^2.5.2",
        "jspdf-autotable": "^3.8.4",
        "ng2-charts": "^8.0.0",
        "ngx-avatars": "^1.8.0",
        "ngx-bootstrap": "^18.0.2",
        "ngx-color-picker": "^17.0.0",
        "ngx-doc-viewer": "^15.0.1",
        "ngx-dropzone-wrapper": "^17.0.0",
        "ngx-summernote": "^1.0.0",
        "ngx-translate-multi-http-loader": "^18.0.0",
        "ngx-ui-switch": "^15.0.0",
        "patch-package": "^8.0.1",
        "postinstall-postinstall": "^2.1.0",
        "rxjs": "~7.8.1",
        "summernote": "^0.8.20",
        "tslib": "^2.3.1",
        "underscore": "^1.13.2",
        "vanilla-js-wheel-zoom": "^6.13.0",
        "xlsx": "^0.18.5",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-eslint/builder": "^18.1.0",
        "@angular-eslint/eslint-plugin": "^18.1.0",
        "@angular-eslint/eslint-plugin-template": "^18.1.0",
        "@angular-eslint/schematics": "^18.1.0",
        "@angular-eslint/template-parser": "^18.1.0",
        "@types/express": "^5.0.1",
        "@types/jasmine": "^5.1.4",
        "@types/jquery": "^3.5.10",
        "@types/node": "^24.5.0",
        "@types/underscore": "^1.11.15",
        "@typescript-eslint/eslint-plugin": "^7.2.0",
        "@typescript-eslint/parser": "^7.2.0",
        "@vendure/ngx-translate-extract": "^10.1.3",
        "browser-sync": "^3.0.0",
        "deepmerge-ts": "^7.1.0",
        "eslint": "^8.57.0",
        "eslint-config-prettier": "^10.0.1",
        "eslint-plugin-import": "^2.25.4",
        "eslint-plugin-jsdoc": "^37.7.0",
        "eslint-plugin-prettier": "^5.2.3",
        "jasmine-core": "~3.5.0",
        "jasmine-spec-reporter": "~5.0.0",
        "karma": "^6.3.9",
        "karma-chrome-launcher": "~3.1.0",
        "karma-coverage-istanbul-reporter": "~3.0.2",
        "karma-jasmine": "~4.0.0",
        "karma-jasmine-html-reporter": "^1.7.0",
        "prettier": "3.3.3",
        "prettier-eslint": "^16.3.0",
        "protractor": "~7.0.0",
        "ts-node": "~8.3.0",
        "typescript": "^5.9.2",
        "xmlhttprequest": "^1.8.0"
    }
}
